module.exports = __webpack_public_path__ + "img/paperResultTitle.84bc6474.png";